import { diagnosticEventLog } from "./DiagnosticEventLog";

/**
 * Records app lifecycle events to the diagnostic event log.
 * Import this module once at app startup (e.g. main.jsx) to start recording.
 */

// App start
diagnosticEventLog.record("lifecycle:app", "info", "app-start", {
  url: window.location.href,
  timestamp: new Date().toISOString(),
});

// Visibility changes (tab switch, minimize, etc.)
document.addEventListener("visibilitychange", () => {
  diagnosticEventLog.record("visibility:app", "info", "visibility-change", {
    state: document.visibilityState,
  });
});

// Online/offline transitions
window.addEventListener("online", () => {
  diagnosticEventLog.record("network:app", "info", "online");
});

window.addEventListener("offline", () => {
  diagnosticEventLog.record("network:app", "warn", "offline");
});

// App close / navigation away
window.addEventListener("beforeunload", () => {
  diagnosticEventLog.record("lifecycle:app", "info", "app-close");
  diagnosticEventLog.flushSync();
});
